import fetchApi from "./fetch";

export type RemnantsManageSelfWarehouse1c = {
  warehouse_id: number;
  name: string;
  /** false = этот физ. склад не привязан к складу МП этой строки */
  connected: boolean;
  remnant_1c: number | null;
  reserved_mp: number | null;
  available_remnant: number | null;
  remnant_synced_at: string | null;
  /** Override доли под комбо на физ. складе; null = нет override (берётся article share_combo). */
  share_in_combo: string | null;
};

export type RemnantsManageRow = {
  row_key?: string;
  article: string;
  name: string;
  is_combo: boolean;
  mp_warehouse_id?: number | null;
  mp_warehouse_name?: string | null;
  marketplace?: string | null;
  mp_is_active?: boolean;
  remnant_1c: number | null;
  remnant_1c_synced_at: string | null;
  warehouse_id?: number | null;
  warehouse_name?: string | null;
  available_remnant: number;
  available_remnant_gross: number;
  /** Срезы 1С по union физ. складов выбранных МП; connected=false → пустая ячейка. */
  self_warehouses_1c?: RemnantsManageSelfWarehouse1c[];
  reserved_wb: number;
  reserved_wb_synced_at: string | null;
  reserved_ozon: number;
  reserved_ozon_synced_at: string | null;
  share_wb: string | null;
  share_ozon: string | null;
  share_combo: string | null;
  /** Фаза D: доля под комбо на выбранном физ. складе (override ?? share_combo); null — склад не выбран. */
  warehouse_combo_share?: string | null;
  wb_blocked: boolean;
  ozon_blocked: boolean;
  /** false = снят с продажи (target 0) */
  in_sale: boolean;
  /** есть активная связь mp_products для склада МП строки */
  mp_linked: boolean;
  wb_quarantine_at: string | null;
  wb_quarantine_reason: string | null;
  ozon_quarantine_at: string | null;
  ozon_quarantine_reason: string | null;
  wb_last_sent: number | null;
  wb_last_sent_at: string | null;
  wb_mp_stock: number | null;
  wb_mp_synced_at: string | null;
  wb_target: number | null;
  wb_need_update: boolean;
  ozon_last_sent: number | null;
  ozon_last_sent_at: string | null;
  ozon_mp_stock: number | null;
  ozon_mp_synced_at: string | null;
  ozon_target: number | null;
  ozon_need_update: boolean;
  has_wb: boolean;
  has_ozon: boolean;
  allocated_to_mp?: number | null;
  allocated_oversell?: boolean;
  wb_mp_formulas?: {
    mp_warehouse_id: number;
    name: string;
    share_formula: string | null;
    new_stock: number | null;
  }[];
  ozon_mp_formulas?: {
    mp_warehouse_id: number;
    name: string;
    share_formula: string | null;
    new_stock: number | null;
  }[];
};

export type RemnantsManageMpWarehouse = {
  id: number;
  name: string;
  marketplace: string;
  is_active: boolean;
};

export type RemnantsManageQuery = {
  page?: number;
  limit?: number;
  search?: string;
  is_combo?: "true" | "false" | "";
  preset?:
    | "reserve_gt_1c"
    | "available_lt_mp"
    | "mp_ne_target"
    | "allocated_oversell"
    | "quarantine"
    | "";
  remnant_1c_min?: number | null;
  remnant_1c_max?: number | null;
  available_min?: number | null;
  available_max?: number | null;
  reserved_wb_min?: number | null;
  reserved_ozon_min?: number | null;
  wb_mp_min?: number | null;
  ozon_mp_min?: number | null;
  /** empty = прочерк, set = есть число */
  ozon_mp_presence?: "empty" | "set" | "";
  wb_mp_presence?: "empty" | "set" | "";
  wb_blocked?: "true" | "false" | "";
  ozon_blocked?: "true" | "false" | "";
  wb_quarantine?: "true" | "false" | "";
  ozon_quarantine?: "true" | "false" | "";
  mp_linked?: "true" | "false" | "";
  in_sale?: "true" | "false" | "";
  /** @deprecated фильтр склада 1С убран со страницы */
  warehouse_id?: number | null;
  /** single id (legacy) */
  mp_warehouse_id?: number | null;
  /** multi select, comma-separated on wire */
  mp_warehouse_ids?: number[];
  tag_ids?: number[];
  sort?: string;
  order?: "ASC" | "DESC";
};

export type RemnantsManageResponse = {
  total: number;
  page: number;
  limit: number;
  warehouses?: { id: number; name: string; is_default: boolean }[];
  mp_warehouses?: RemnantsManageMpWarehouse[];
  /** Union физ. складов по выбранным складам МП — заголовки колонок 1С. */
  bound_self_warehouses?: { id: number; name: string }[];
  selected_mp_warehouse_ids?: number[];
  selected_mp_warehouse?: {
    id: number;
    name: string;
    marketplace: string;
  } | null;
  items: RemnantsManageRow[];
};

const qs = (query?: RemnantsManageQuery) => {
  const params = new URLSearchParams();
  if (!query) return "";
  Object.entries(query).forEach(([k, v]) => {
    if (v === undefined || v === null || v === "") return;
    if (k === "tag_ids" && Array.isArray(v)) {
      if (!v.length) return;
      params.set(k, v.join(","));
      return;
    }
    if (k === "mp_warehouse_ids" && Array.isArray(v)) {
      if (!v.length) return;
      params.set(k, v.join(","));
      return;
    }
    params.set(k, String(v));
  });
  const s = params.toString();
  return s ? `?${s}` : "";
};

export const getRemnantsManage = async (
  query?: RemnantsManageQuery
): Promise<RemnantsManageResponse> => {
  const res = await fetchApi(`/api/remnants/manage${qs(query)}`);
  if (!res.ok) throw new Error("remnants manage failed");
  return res.json();
};

export type WarehouseOverviewView =
  | "top_reserve"
  | "top_remnant"
  | "remnant_asc";

export type WarehouseOverviewAlertCounts = {
  allocated_oversell: number;
  reserve_gt_1c: number;
  available_lt_mp: number;
  mp_ne_target: number;
  quarantine: number;
};

export type WarehouseOverviewItem = {
  article: string;
  name: string | null;
  is_combo: boolean;
  remnant_1c: number;
  reserved_mp: number;
  mp_fact: number;
  delta_mp_1c: number;
  allocated: number;
};

export type WarehouseOverviewOrderLimitTile = {
  kind: "meta" | "self_meta";
  id: number;
  name: string;
  marketplace: string | null;
  used: number;
  /** Exact from WB supply-token match */
  used_from_supply?: number;
  /** Waterfall / single-link attribution */
  used_from_rules?: number;
  limit: number | null;
  tripped: boolean;
  is_active: boolean;
  is_default?: boolean;
  settings_path: string;
  parent_mp_warehouse_id?: number;
  self_warehouse_id?: number;
};

export type WarehouseOverviewMpLimit = {
  id: number;
  name: string;
  marketplace: string;
  limit: number | null;
  used: number;
  tripped: boolean;
  is_active: boolean;
};

export type WarehouseOverviewOrderLimits = {
  day: string;
  limit_self: number | null;
  used_self: number;
  used_from_supply?: number;
  used_from_rules?: number;
  tripped_self: boolean;
  inactive_mp_count: number;
  mp_warehouses: WarehouseOverviewMpLimit[];
};

export type WarehouseOverviewWarehouse = {
  id: number;
  name: string;
  is_default: boolean;
  view: WarehouseOverviewView;
  summary: {
    remnant_sum: number;
    reserved_1c_sum: number;
    reserved_mp_sum: number;
    allocated_sum: number;
    article_count: number;
  };
  counts: WarehouseOverviewAlertCounts;
  order_limits?: WarehouseOverviewOrderLimits;
  items: WarehouseOverviewItem[];
};

export type WarehouseOverviewResponse = {
  views: Record<string, WarehouseOverviewView>;
  day?: string;
  order_limit_tiles?: WarehouseOverviewOrderLimitTile[];
  warehouses: WarehouseOverviewWarehouse[];
};

export const getWarehouseOverview = async (query?: {
  views?: string;
}): Promise<WarehouseOverviewResponse> => {
  const res = await fetchApi(
    `/api/remnants/manage/warehouse_overview${qs(query as any)}`
  );
  if (!res.ok) throw new Error("warehouse overview failed");
  return res.json();
};

export const setOrderLimitsRemnantsManage = async (body: {
  self_warehouse_id?: number;
  mp_warehouse_id?: number;
  order_limit_self?: number | null;
  order_limit?: number | null;
}) => {
  const res = await fetchApi(`/api/remnants/manage/order_limits`, {
    method: "POST",
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error("set order limits failed");
  return res.json() as Promise<{
    ok: boolean;
    self_warehouse_id?: number;
    mp_warehouse_id?: number;
    order_limit_self?: number;
    order_limit?: number;
    error?: string;
  }>;
};

export const forceSendRemnantsManage = async (body: {
  articles: string[];
  marketplace?: "ozon" | "wildberries" | "both";
}) => {
  const res = await fetchApi(`/api/remnants/manage/force_send`, {
    method: "POST",
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error("force send failed");
  return res.json() as Promise<{
    ok: boolean;
    marked: { wb: number; ozon: number };
    sent: { wb: number; ozon: number };
  }>;
};

export const clearQuarantineRemnantsManage = async (body: {
  articles: string[];
  marketplace?: "ozon" | "wildberries" | "both";
}) => {
  const res = await fetchApi(`/api/remnants/manage/clear_quarantine`, {
    method: "POST",
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error("clear quarantine failed");
  return res.json() as Promise<{
    ok: boolean;
    cleared: { wb: number; ozon: number };
    enqueued: number;
  }>;
};

export const setBlockRemnantsManage = async (body: {
  articles: string[];
  marketplace?: "ozon" | "wildberries" | "both";
  blocked: boolean;
}) => {
  const res = await fetchApi(`/api/remnants/manage/set_block`, {
    method: "POST",
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error("set block failed");
  return res.json() as Promise<{
    ok: boolean;
    updated: { wb: number; ozon: number };
    enqueued: number;
  }>;
};

export const setInSaleRemnantsManage = async (body: {
  articles: string[];
  marketplace?: "ozon" | "wildberries" | "both";
  in_sale: boolean;
}) => {
  const res = await fetchApi(`/api/remnants/manage/set_in_sale`, {
    method: "POST",
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error("set in_sale failed");
  return res.json() as Promise<{
    ok: boolean;
    updated: { wb: number; ozon: number };
    enqueued: number;
  }>;
};

export const setShareFormulaBulkRemnantsManage = async (body: {
  articles: string[];
  marketplace?: "ozon" | "wildberries" | "both";
  share_formula: string;
}) => {
  const res = await fetchApi(`/api/remnants/manage/set_share_formula_bulk`, {
    method: "POST",
    body: JSON.stringify(body),
  });
  const data = (await res.json()) as {
    ok: boolean;
    error?: string;
    share_formula?: string | null;
    updated?: { wb: number; ozon: number };
    recomputed_articles?: string[];
  };
  if (!res.ok || !data.ok) {
    throw new Error(
      data.error === "invalid formula"
        ? "Некорректная формула"
        : data.error || "set share formula failed"
    );
  }
  return data as {
    ok: true;
    share_formula: string | null;
    updated: { wb: number; ozon: number };
    recomputed_articles: string[];
  };
};

export const setShareFormulaRemnantsManage = async (body: {
  article: string;
  mp_warehouse_id: number;
  share_formula: string | null;
}) => {
  const res = await fetchApi(`/api/remnants/manage/set_share_formula`, {
    method: "POST",
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error("set share formula failed");
  return res.json() as Promise<{
    ok: boolean;
    article?: string;
    mp_warehouse_id?: number;
    share_formula?: string | null;
    recomputed_articles?: string[];
  }>;
};

/** Фаза D: доля под комбо на конкретном физическом складе (warehouse_remnants.share_in_combo). */
export const setComboShareFormulaRemnantsManage = async (body: {
  article: string;
  warehouse_id: number;
  share_formula: string | null;
}) => {
  const res = await fetchApi(`/api/remnants/manage/set_combo_share_formula`, {
    method: "POST",
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error("set combo share formula failed");
  return res.json() as Promise<{
    ok: boolean;
    article?: string;
    warehouse_id?: number;
    share_formula?: string | null;
    recomputed_articles?: string[];
  }>;
};

/** Test-only: ручная правка числа заказов (warehouse_mp_reserved) + локальный водопад. */
export const setMpReservedRemnantsManage = async (body: {
  article: string;
  mp_warehouse_id: number;
  qty: number;
}) => {
  const res = await fetchApi(`/api/remnants/manage/set_mp_reserved`, {
    method: "POST",
    body: JSON.stringify(body),
  });
  if (!res.ok) throw new Error("set mp reserved failed");
  return res.json() as Promise<{
    ok: boolean;
    article?: string;
    mp_warehouse_id?: number;
    qty?: number;
    recomputed_articles?: string[];
  }>;
};

/**
 * Локальный водопад (без load MP stock/reserved и без send).
 * Пустой / omitted articles = весь каталог.
 */
export const recomputeRemnantsManage = async (body?: {
  articles?: string[];
}) => {
  const res = await fetchApi(`/api/remnants/manage/recompute`, {
    method: "POST",
    body: JSON.stringify(body || {}),
  });
  if (!res.ok) throw new Error("recompute failed");
  return res.json() as Promise<{
    ok: boolean;
    scope: "selected" | "all";
    articles: string[];
  }>;
};

/** Полный remnants_pipeline вне расписания (очередь). */
export const runPipelineRemnantsManage = async () => {
  const res = await fetchApi(`/api/remnants/manage/run_pipeline`, {
    method: "POST",
    body: JSON.stringify({}),
  });
  if (!res.ok) throw new Error("run pipeline failed");
  return res.json() as Promise<{
    ok: boolean;
    queued: boolean;
    job_id?: string;
    job_name?: string;
    reason?: "already_queued";
  }>;
};

export type AvailableExplainResult = {
  ok: boolean;
  article?: string;
  is_combo?: boolean;
  warehouse_id?: number;
  warehouse_name?: string | null;
  available?: number;
  gross?: number;
  lines: string[];
};

/** Разбор available на физ. складе (хинт). */
export const explainAvailableRemnantsManage = async (query: {
  article: string;
  warehouse_id: number;
}): Promise<AvailableExplainResult> => {
  const res = await fetchApi(
    `/api/remnants/manage/explain_available${qs({
      article: query.article,
      warehouse_id: query.warehouse_id,
    } as any)}`
  );
  if (!res.ok) throw new Error("explain available failed");
  return res.json();
};
